var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradebookfilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.107 2H5.043C3.915 2 3 2.915 3 4.043v2.491h1.444c.569 0 1.037.468 1.037 1.037 0 .57-.468 1.027-1.037 1.027H3v2.603h1.444c.569 0 1.037.467 1.037 1.037 0 .569-.468 1.037-1.037 1.037H3v2.602h1.444c.569 0 1.037.468 1.037 1.037 0 .57-.468 1.047-1.037 1.047H3v1.952c0 1.129.915 2.044 2.043 2.044h13.064c1.129 0 2.044-.915 2.044-2.044V4.043C20.14 2.915 19.226 2 18.107 2zm-3.243 9.424l-1.19 1.16.286 1.626c.05.305-.265.549-.54.407h-.01l-1.463-.773-1.464.773c-.265.132-.6-.082-.55-.407l.285-1.627-1.2-1.159c-.111-.111-.121-.274-.091-.386.04-.112.142-.234.315-.254l1.627-.234.732-1.484c.142-.295.549-.295.681 0l.732 1.474 1.647.244c.274.05.437.406.203.64z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H17.141V19.947H0z",
    transform: "translate(3 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradebookfilled);
export default __webpack_public_path__ + "static/media/gradebook.filled.340685fc71f9065ca9803af3264a432d.svg";
export { ForwardRef as ReactComponent };